import {
  ExpressCheckoutAddress,
  StripeExpressCheckoutElementConfirmEvent,
} from '@stripe/stripe-js'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'

const extractNameFields = (name: string | undefined) => {
  const fields: Partial<Record<FieldSlugEnum, string>> = {}

  if (!name) {
    return fields
  }

  const trimmedName = name.trim()

  if (!trimmedName) {
    return fields
  }

  fields[FieldSlugEnum.FullName] = trimmedName

  const nameParts = trimmedName.split(/\s+/)

  if (nameParts.length > 0) {
    fields[FieldSlugEnum.FirstName] = nameParts[0]
  }

  if (nameParts.length > 1) {
    fields[FieldSlugEnum.LastName] = nameParts.slice(1).join(' ')
  }

  return fields
}

const extractAddressFields = (address: ExpressCheckoutAddress | undefined) => {
  const fields: Partial<Record<FieldSlugEnum, string>> = {}

  if (!address) {
    return fields
  }

  if (address.country) {
    fields[FieldSlugEnum.Country] = address.country
  }

  if (address.state) {
    fields[FieldSlugEnum.State] = address.state
  }

  if (address.city) {
    fields[FieldSlugEnum.City] = address.city
  }

  if (address.postal_code) {
    fields[FieldSlugEnum.Postcode] = address.postal_code
  }

  const streetAddress = [address.line1, address.line2]
    .filter((value): value is string => !!value)
    .join(', ')

  if (streetAddress) {
    fields[FieldSlugEnum.StreetAddress] = streetAddress
  }

  return fields
}

export const extractApplePayFields = (
  event: StripeExpressCheckoutElementConfirmEvent,
  isShippingEnabled: boolean,
): Partial<Record<FieldSlugEnum, string>> => {
  const fields: Partial<Record<FieldSlugEnum, string>> = {}

  if (event.billingDetails?.email) {
    fields[FieldSlugEnum.Email] = event.billingDetails.email
  }

  if (event.billingDetails?.phone) {
    fields[FieldSlugEnum.PhoneNumber] = event.billingDetails.phone
  }

  Object.assign(
    fields,
    extractNameFields(
      event.billingDetails?.name || event.shippingAddress?.name,
    ),
  )

  const address = isShippingEnabled
    ? event.shippingAddress?.address || event.billingDetails?.address
    : event.billingDetails?.address

  Object.assign(fields, extractAddressFields(address))

  return fields
}
